export default "__VITE_ASSET__BcFStH1C__"